import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const QuotedMessageAudioFileIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M2 5.99999V9.99999H4.66667L8 13.3333V2.66665L4.66667 5.99999H2ZM6.66667 5.88665V10.1133L5.22 8.66665H3.33333V7.33332H5.22L6.66667 5.88665ZM11 7.99999C11 6.81999 10.32 5.80665 9.33333 5.31332V10.68C10.32 10.1933 11 9.17999 11 7.99999ZM9.33333 2.15332V3.52665C11.26 4.09999 12.6667 5.88665 12.6667 7.99999C12.6667 10.1133 11.26 11.9 9.33333 12.4733V13.8467C12.0067 13.24 14 10.8533 14 7.99999C14 5.14665 12.0067 2.75999 9.33333 2.15332Z" />
  </Icon>
);

export default memo(QuotedMessageAudioFileIcon);
